@if (loading()) {
  <p class="cg-form-help">Loading activity…</p>
} @else if (items().length === 0) {
  <app-admin-empty-state icon="clock" title="No activity yet" description="Actions on this request will appear here." />
} @else {
  <ul class="fr-activity">
    @for (item of items(); track item._id; let last = $last) {
      <li class="fr-activity__item" [class.fr-activity__item--last]="last">
        <span class="fr-activity__dot" aria-hidden="true"></span>
        <div class="fr-activity__body">
          <strong class="fr-activity__title">{{ title(item) }}</strong>
          @if (detail(item); as d) {
            <p class="fr-activity__detail">{{ d }}</p>
          }
          <time class="fr-activity__time">{{ item.createdAt | date: 'medium' }}</time>
        </div>
      </li>
    }
  </ul>
}
